import { FC } from 'react'
import shallow from 'zustand/shallow'

import { TargetModalType } from './types'
import { useTargetsModalStore } from './TargetsModalStore'
import { TargetsModalFormNewTarget } from './TargetsModalFormNewTarget'
import { TargetsModalFormViewTarget } from './TargetsModalFormViewTarget'
import { TargetsModalFormNewPastTarget } from './TargetsModalFormNewPastTarget'
import { TargetsModalFormEditPastTarget } from './TargetsModalFormEditPastTarget'
import { TargetsModalFormSuggestedTarget } from './TargetsModalFormSuggestedTarget'
import { TargetsModalFormEditActiveTarget } from './TargetsModalFormEditActiveTarget'
import { TargetsModalFormResignedEmployeeTarget } from './TargetsModalFormResignedEmployeeTarget'
import { TargetsModalFormDuplicateAndDismissOrDeleteTarget } from './TargetsModalFormDuplicateAndDismissOrDeleteTarget'
import { TargetsModalFormDeleteTarget } from './TargetsModalFormDeleteTarget'

export const TargetsModalContent: FC = () => {
  const [targetModalType] = useTargetsModalStore((state) => [state.targetModalType], shallow)

  return (
    <>
      {targetModalType === TargetModalType.viewTarget && <TargetsModalFormViewTarget />}
      {targetModalType === TargetModalType.viewTargetInMeeting && <TargetsModalFormViewTarget />}
      {targetModalType === TargetModalType.appraisalNewTarget && <TargetsModalFormNewTarget />}
      {targetModalType === TargetModalType.appraisalNewPastTarget && <TargetsModalFormNewPastTarget />}
      {targetModalType === TargetModalType.appraisalEditActiveTarget && <TargetsModalFormEditActiveTarget />}
      {targetModalType === TargetModalType.appraisalEditPastTarget && <TargetsModalFormEditPastTarget />}
      {targetModalType === TargetModalType.appraisalSuggestedTarget && <TargetsModalFormSuggestedTarget />}
      {targetModalType === TargetModalType.resignedEmployeViewTarget && <TargetsModalFormResignedEmployeeTarget />}
      {targetModalType === TargetModalType.deleteTarget && <TargetsModalFormDeleteTarget />}
      {[TargetModalType.duplicateAndDismissOrDeleteTarget, TargetModalType.duplicateAndDismissOrDeletePastTarget].includes(
        targetModalType,
      ) && <TargetsModalFormDuplicateAndDismissOrDeleteTarget />}
    </>
  )
}
